<template>
    <CustomAutocomplete :completeFunction="search" :emptyValue="false" :dropdown="dropdown" v-model="internalValue"
                        :name="name" :label="label" :width="width" :customErrorMessage="customErrorMessage"
                        :itemFromQuery="false" :disabled="disabled" :required="required" :field="searchParam"
                        :showErrors="showErrors" completeOnFocus/>
</template>

<script>
import {searchHorseForPedigree} from "@/swagger/vue-api-client";
    import CustomAutocomplete from "@/components/form/inner/CustomAutocomplete.vue";

    export default {
        name: "CustomAutocompleteHorse",
        components: {CustomAutocomplete},
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            modelValue: null,
            searchParam: {
                type: String,
                default: "name",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: null,
            },
            horseSex: {
                type: String,
                default: null,
            }
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
        },

        data() {
            return {
                items: [],
                selectedValue: null,
                search: async (obj) => {
                    const { query } = obj;
                    let parameters = {
                        query: query,
                    }
                    if (this.horseSex !== null) {
                        if (this.horseSex === 'STALLION') {
                            parameters.horseParentsType = 'SIRE'
                        } else if (this.horseSex === 'BROODMARE') {
                            parameters.horseParentsType = 'DAM'
                        }
                    }
                    return searchHorseForPedigree(parameters);
                },
            };
        },

    };
</script>

<style scoped>

</style>
